import React, { useEffect, useState } from "react";
import styleClasses from "../../Header/Header.module.scss";
import {useStoreLocation} from "../../../context/StoreLocation";
import {
  DELIVERY_ORDER_TYPE,
  GUEST_USER,
  OFFER_TYPE_FIXED_DISCOUNT,
  PICK_UP_ORDER_TYPE,
} from "../../../constants";
import ItemPickupDeliveryModal from "../../ItemGrid/ItemPickupDeliveryModal";
import {persistZero, getUser, isCartItemsUnavailable, isCartModifiersUnavailable, roundNumber, roundNumberHalfUpStrategy} from "../../../helpers/helperMethods";
import {roundToTwo, toFixedNumber} from "../../../priceCalculation/helper";
import {Modal} from "react-bootstrap";
import OrderType from "../../ItemGrid/OrderType";
import { useAppSelector } from "../../../redux/store/store";
import useGetProfileStatus from "../../../react-query-hooks/useGetProfileStatus";
import GuestLoginModal from "../GuestCheckoutModal/GuestCheckout/GuestLoginModal";
import { useDispatch } from "react-redux";
import { updateRewardDiscountedSubTotal } from "../../../redux/slices/cartSlice";
import { updateCartBilling } from "../../../redux/slices/checkoutSlice";
import { brazeLogCustomEventCheckoutStarted } from "../../../helpers/brazeHelper";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { updateStartedCheckoutBrazeEvent } from "../../../redux/slices/itemSlice";

/*
 * TODO: use context to get list of items added in cart and calculate the bill
 */
interface IBillingProps {
  StyleBtn?: any,
  CartBtnCheckout?: any,
  TotalList?: any,
  StyleCheckout?: any,
  handleShowPickupMethodModal?: boolean,
  handleClosePickupMethodModal?: boolean,
  handleShowDeliveryMethodModal?: boolean,
  handleCloseDeliveryMethodModal?: boolean ,
  CheckoutBtnHide?: any,
  OrderTotal?: any,
  listspace?: any,
  isOrderTypeSelected?: boolean;
  orderType?: string;
  cartItems: any;
  isOrdered?: boolean;
  titleStyle?: string;
  authInfo?: any;
  orderTippingAmount?: number;
  isCheckoutBilling?: boolean;
  order?: any;
  tax?: number;
  titlespace?:string;
  setTotal?: (number) => void;
  setRewardsDiscountedSubTotal?: (value: number) => void // Used for offer redemption calculation
  setDiscountedSubTotal?: (value: number) => void; 
  handleTax?:boolean
  offerDiscount?:number;
  disableCheckout?:boolean;
  offerDiscountType?: string;
}

const Billing = (props: IBillingProps) => {
  const {
    StyleBtn, 
    CartBtnCheckout,
    TotalList,
    StyleCheckout , 
    handleShowPickupMethodModal,
    handleShowDeliveryMethodModal ,
    CheckoutBtnHide,
    OrderTotal,
    listspace,
    isOrderTypeSelected,
    orderType,
    cartItems = [],
    isOrdered,
    titleStyle,
    authInfo,
    orderTippingAmount,
    isCheckoutBilling,
    tax,
    order,
    titlespace,
    setTotal,
    setRewardsDiscountedSubTotal,
    setDiscountedSubTotal,
    offerDiscount,
    disableCheckout,
    handleTax = true,
    offerDiscountType
  } = props;
  const [currentUser , setCurrentUser] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  })
  const CartBilling = useAppSelector((state) => state.cart);
  const startedCheckoutBrazeEvent = useAppSelector(state => state.Items.startedCheckoutBrazeEvent);
  
  const [openPickupMethodModal, setOpenPickupMethodModal] = useState(false);
  const [openDeliveryMethodModal, setOpenDeliveryMethodModal] = useState(false);
  const [ handleChangeOrderType ,  setHandleChangeOrderType] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [changeOrderType, setChangeOrderType] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(false);
  const handleShowContactForm = () => setShowContactForm(true);
  const handleCloseContactForm = () => setShowContactForm(false);
  const { locationInfo } = useStoreLocation();
  const [displaySubTotal, setDisplaySubTotal] = useState<number>(0);
  const [displayDiscount, setDisplayDiscount] = useState<number>(0);
  let authUser = getUser();
  const dispatch = useDispatch();
  const {data: userProfileData} = useGetProfileStatus(authUser?.id, authUser?.type)
  const savedOrderType = orderType
  let cart = cartItems
  const delivery_fee = CartBilling.free_delivery ? 0 : CartBilling?.delivery_fee;
  const service_fee = CartBilling.free_delivery ? 0 : CartBilling?.service_fee;

  const isItMobile = useCheckMobileScreen();


  useEffect(() => {
    if(startedCheckoutBrazeEvent.triggerEvent) {
      const total:any = persistZero(roundNumber(calculateTotal(),2));
      brazeLogCustomEventCheckoutStarted(CartBilling, {discount: CartBilling?.discount, tax: CartBilling.tax, subTotal: CartBilling.gross_sales, total}, isItMobile, CartBilling?.orderDetails?.PickupSlotDetails);
      dispatch(updateStartedCheckoutBrazeEvent({isSent: true}));
    }
  },[startedCheckoutBrazeEvent.triggerEvent])

  useEffect(() => {
    calculateSubTotal();
  }, [cart, offerDiscount]);

  useEffect(() => {
    if (handleShowPickupMethodModal) { setOpenPickupMethodModal(true) }
    if (handleShowDeliveryMethodModal) { setOpenDeliveryMethodModal(true)}
  }, [ 
    handleShowPickupMethodModal, 
    handleShowDeliveryMethodModal, 

  ]);
  function calculateTax(): number {
    if(handleTax){
      return CartBilling?.tax
    }else{
      return 0
    }
  }

  const calculateOfferDiscount = (rewardDiscountTotal: number, totalAmount: number) => {
    if (!offerDiscount) return 0;
    if(offerDiscountType === OFFER_TYPE_FIXED_DISCOUNT)
    {
      return offerDiscount
    }
    else {
      const discount = (totalAmount - rewardDiscountTotal) * offerDiscount / 100;
      return roundNumberHalfUpStrategy(discount, 2);
    }
  }

  function calculateSubTotal() {
    if(isCheckoutBilling) {
      setDisplaySubTotal(CartBilling?.gross_sales);
      setDisplayDiscount(CartBilling?.discount);
      setDiscountedSubTotal(toFixedNumber(CartBilling?.net_sales));
      return;
    }
    if (cart.length > 0) {
      let displayTotal= 0;
      let rewardDiscountTotal = 0
      cart.forEach((item: any) => {
        const price = item.gross_price ?? item.display_price
        displayTotal += toFixedNumber(price * item.quantity)
        if (item?.reward_redeemed || item.redemption_by_points) {
          rewardDiscountTotal +=  (item.discount_amount || item.discount || item.base_price)
        }
      });
      setDisplaySubTotal(displayTotal)
      const discountByOffer = calculateOfferDiscount(rewardDiscountTotal, displayTotal)
      const overAllDiscount = rewardDiscountTotal + discountByOffer;
      setRewardsDiscountedSubTotal?.(toFixedNumber(displayTotal - rewardDiscountTotal));
      dispatch(updateRewardDiscountedSubTotal(toFixedNumber(displayTotal - rewardDiscountTotal)));
      setDisplaySubTotal(displayTotal)
      if (overAllDiscount > displayTotal) {
        setDiscountedSubTotal?.(0);
        setDisplayDiscount(toFixedNumber(displayTotal)); 
      } else {
        setDisplayDiscount(toFixedNumber(overAllDiscount))
        setDiscountedSubTotal?.(toFixedNumber(displayTotal - overAllDiscount));
      }
    } else {
      setDisplaySubTotal(0)
      setDisplayDiscount(0)
    }
  }

  useEffect(() => {
    calculateTotal();
  },[CartBilling?.tax])

  const calculateDiscountedTotal = () => {
    let discountedTotal = isCheckoutBilling ? CartBilling?.net_sales : displaySubTotal - displayDiscount
    let grandTotal = orderTippingAmount ? discountedTotal + orderTippingAmount : discountedTotal;
    if(savedOrderType === DELIVERY_ORDER_TYPE && cart?.length){
      grandTotal = grandTotal + delivery_fee + service_fee
    }
    return grandTotal >= 0 ? grandTotal : 0
  }

  function calculateTotal(): number {
    const total = locationInfo?.selectedStore?.tax_rate
    ? calculateDiscountedTotal() + calculateTax()
    : calculateDiscountedTotal();
    setTotal?.(Number(roundNumber(total,2)))
    return total
  }
  
   const handleClosePickupMethodModal = () => { setOpenPickupMethodModal(false) }
   const handleCloseDeliveryMethodModal =  () => { 
    setOpenDeliveryMethodModal(false)
    setOpenPickupMethodModal(false)
  }

  useEffect(()=>{
    let authUser = getUser()
    if( authUser.isInfo ){
       setCurrentUser({ ...authUser})
      //  setShowContactInfo(true)
    }
  } , [showContactForm])

  const onCheckout = async () => {
    //check if user is guest
    if( authUser.type === GUEST_USER || userProfileData?.update_required){
        if(authUser.isInfo || userProfileData?.update_required)  setShowContactInfo(true)
        else setShowContactInfo(false)
      handleShowContactForm()
    } else {
      showOrderTypeModal()
    }
  }

  const showOrderTypeModal = () => {
    // setHandleChangeOrderType(true)
    if(isOrderTypeSelected && savedOrderType == PICK_UP_ORDER_TYPE){
      setOpenPickupMethodModal(true)
      setOpenDeliveryMethodModal(false)
    }else{
      setOpenDeliveryMethodModal(true);
      setOpenPickupMethodModal(false)
    }
  }

  const closeOrderTypeModal = () => {
    setChangeOrderType(false)
    showOrderTypeModal()
  }

  const closeChangeOrderTypeModal = () => {
    setChangeOrderType(false)
  }

  const showChangeOrderType = (changeType) => {
    setChangeOrderType(changeType)
  }

  const totalForPlacedOrder = () => {
    let grandTotal = orderTippingAmount ? order?.total_price + orderTippingAmount : order?.total_price;
    return roundToTwo(Number(grandTotal))
  }

  const taxShow = () => {
    if(handleTax){
      return         <li>
      Tax
      <span className="d-inline-block ms-3" data-testid='checkout-tax'>{isOrdered ? `$${roundNumber(tax,2)}` : `\$${toFixedNumber(CartBilling?.tax)}`}</span>
    </li>
    }else return null
  }

  useEffect(() => {
    if (!isOrdered && isCheckoutBilling) {
      const subTotal = orderType === DELIVERY_ORDER_TYPE ?
        CartBilling?.net_sales + delivery_fee + service_fee
        : CartBilling?.net_sales;
      dispatch(updateCartBilling({
        'sub_total': Number(roundNumber(subTotal, 2)),
        'discount': displayDiscount,
        'net_sales': CartBilling?.net_sales,
        'total_price': Number(roundNumber(calculateTotal(), 2)),
        'tax': CartBilling?.tax,
        'gross_sales': displaySubTotal
      }))
    }
  }, [displaySubTotal, displayDiscount, orderTippingAmount, CartBilling?.tax]);

  return (
    <>
    <div className={`${StyleCheckout}`}>
     <h4 className={`pt-3 text-start h-22 ls-normal lh-normal font-Cls fw-normal f-sm-s16 f-s20 px-4 mb-0 ${titleStyle} ${titlespace}`}>
        Order Total
      </h4>
      <ul className={`${styleClasses.total_count_list} ${listspace} ${TotalList} list-inline`}>
        <li>
          Subtotal
          <span className="d-inline-block ms-3" data-testid="subTotalPriceCart">{isOrdered ? `$${order?.gross_sales?.toFixed(2)}` :`\$${persistZero(toFixedNumber(displaySubTotal))}`}</span>
        </li>
              {order?.discount || displayDiscount > 0 ?
                  <li className={`text-danger`}>
                    Discount
                    <span className="d-inline-block ms-3">{`\$${ order?.discount?.toFixed(2) || roundNumber(displayDiscount, 2) }`}</span>
                  </li>
                  :
                  null
              }
              {taxShow()}
        {orderTippingAmount ? <li>
          Tip
          <span className="d-inline-block ms-3" data-testid='checkout-tip'>${`${roundNumber(orderTippingAmount,2)}`}</span>
        </li> : null}
        {orderType == DELIVERY_ORDER_TYPE && cart?.length && !isOrdered ?
            <>
              <li className={`${
                    CartBilling.free_delivery && 'text-danger'
                  }`}>
                Delivery Fee
                <span className="d-inline-block ms-3">${delivery_fee}</span>
              </li>
              <li className={`${
                    CartBilling.free_delivery && 'text-danger'
                  }`}>
                Service Fee
                <span className="d-inline-block ms-3">${service_fee}</span>
              </li>
            </>
            : null}
        {orderType == DELIVERY_ORDER_TYPE && isOrdered ?
            <>
            { order?.delivery_fee ? <li className={`${
                    order?.free_delivery && 'text-danger'
                  }`}>Delivery Fee <span className={`d-inline-block ms-3`}>${order?.delivery_fee?.toFixed(2)}</span> </li> : null}
            { order?.service_fee ? <li className={`${
                    order?.free_delivery && 'text-danger'
                  }`}>Service Fee <span className={`d-inline-block ms-3`}>${order?.service_fee?.toFixed(2)}</span> </li> : null}
            </>
            : null}
        <li>
          Total
          {isOrdered
            ?<a className="d-inline-block ms-3 text-decoration-none clr-dark-grey" href="javascript:void(0);">{isOrdered ? `$${persistZero(totalForPlacedOrder())}` : `$${persistZero(roundNumber(calculateTotal(),2))}`}</a>
            :<span className="d-inline-block ms-3">{isOrdered ? `$${persistZero(totalForPlacedOrder())}` : `$${persistZero(roundNumber(calculateTotal(),2))}`}</span>}
        </li>
      </ul>
      {
          !isCheckoutBilling && !isOrdered ? 
      <div className={`${styleClasses.checkout_btn_wrap} ${CartBtnCheckout}  ${StyleBtn}`}>
       
          <button
          type="button"
          className={`btn btn-large w-100 text-uppercase mb-3 d-flex justify-content-between `}
          disabled={cart.length <= 0 || isCartItemsUnavailable(cart) || isCartModifiersUnavailable(cart) || disableCheckout}
          onClick={onCheckout}
          id={'checkout-button'}
          data-testid="checkout-cart"
        >
          Checkout
            <span className="d-inline-block ms-3">${persistZero(roundNumber(calculateTotal(),2))}</span>
        </button> 
      
      </div>: null
        }
     </div>
     <ItemPickupDeliveryModal 
        subTotal={toFixedNumber(displaySubTotal)}
        tax={toFixedNumber(calculateTax())}
        total={toFixedNumber(calculateTotal())}
        openPickupMethodModal={openPickupMethodModal} 
        handleClosePickupMethodModal={handleClosePickupMethodModal}
        editPickupType={showChangeOrderType}
        editDeliveryType={showChangeOrderType}
        handleCloseDeliveryMethodModal={handleCloseDeliveryMethodModal}
        openDeliveryMethodModal={openDeliveryMethodModal}  
        handleChangeOrderType={handleChangeOrderType} 
        isCartBilling={true}
        locationId={locationInfo?.selectedStore?.id}
        cartItems={cartItems}
        userId={authInfo?.userId}
      />
     <GuestLoginModal 
        showContactForm={showContactForm}
        handleCloseContactForm={handleCloseContactForm}
        subTotal={displaySubTotal}
     />
      <Modal
          show={changeOrderType}
          centered
          className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
          onHide={closeChangeOrderTypeModal}
          size="sm"
      >
        <Modal.Header className="x-4 justify-content-center">
          <button
              type="button"
              className="btn modal-close-button pe-0 sm-blue-icon"
              onClick={closeChangeOrderTypeModal}
          >
            Close
          </button>
        </Modal.Header>
        <Modal.Body>
          <OrderType
              handleShowDeliveryMethodModal={closeOrderTypeModal}
              handleShowPickupMethodModal={closeOrderTypeModal}
              handleOrderTypeModal={closeChangeOrderTypeModal}
              changeToDelivery={orderType == PICK_UP_ORDER_TYPE}
              changeToPickup={orderType == DELIVERY_ORDER_TYPE}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Billing;